import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Turno from "@/pages/Turno";
import Cronologia from "@/pages/Cronologia";
import Fatture from "@/pages/Fatture";
import Classifica from "@/pages/Classifica";
import Personale from "@/pages/Personale";
import Listino from "@/pages/Listino";
import Ruoli from "@/pages/Ruoli";
import GestioneSwap from "@/pages/GestioneSwap";
import Importazioni from "@/pages/Importazioni";
import Compensi from "@/pages/Compensi";
import Support from "@/pages/Support";
import SwapPage from "@/pages/SwapPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-blue-400 ot-mono tracking-widest">
        <span className="ot-blink">CONNESSIONE...</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/turno" element={<Protected><Turno /></Protected>} />
      <Route path="/cronologia" element={<Protected><Cronologia /></Protected>} />
      <Route path="/fatture" element={<Protected><Fatture /></Protected>} />
      <Route path="/swap" element={<Protected><SwapPage /></Protected>} />
      <Route path="/compensi" element={<Protected><Compensi /></Protected>} />
      <Route path="/classifica" element={<Protected><Classifica /></Protected>} />
      <Route path="/supporto" element={<Protected><Support /></Protected>} />
      <Route path="/personale" element={<Protected><Personale /></Protected>} />
      <Route path="/listino" element={<Protected><Listino /></Protected>} />
      <Route path="/ruoli" element={<Protected><Ruoli /></Protected>} />
      <Route path="/gestione-swap" element={<Protected><GestioneSwap /></Protected>} />
      <Route path="/import" element={<Protected><Importazioni /></Protected>} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster
            theme="dark"
            position="top-right"
            toastOptions={{
              style: {
                background: "#0B101A",
                border: "1px solid rgba(0,229,255,0.2)",
                color: "#F8FAFC",
                fontFamily: "'IBM Plex Sans', sans-serif",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
